import { createFileRoute, Outlet, useNavigate, Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { useSession } from "../lib/auth";
import { useSuperadminCheck } from "../hooks/useSuperadmin";
import { Button } from "@wondermaps/ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldXmark } from "@fortawesome/pro-solid-svg-icons/faShieldXmark";

export const Route = createFileRoute("/superadmin")({
  component: SuperadminLayout,
});

function SuperadminLayout() {
  const navigate = useNavigate();
  const { data: session, isPending: isSessionLoading } = useSession();
  const { data: superadminData, isPending: isSuperadminLoading } =
    useSuperadminCheck(!!session?.user);
  const isSuperadmin = superadminData?.isSuperadmin ?? false;

  useEffect(() => {
    if (!isSessionLoading && !session?.user) {
      navigate({
        to: "/login",
        search: { redirect: window.location.pathname },
      });
    }
  }, [isSessionLoading, session, navigate]);

  if (isSessionLoading || isSuperadminLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-muted">
        <div className="text-center">
          <div className="mb-2 h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent mx-auto" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!session?.user) {
    return null;
  }

  if (!isSuperadmin) {
    return (
      <div className="flex h-screen flex-col items-center justify-center bg-muted">
        <FontAwesomeIcon
          icon={faShieldXmark}
          className="h-16 w-16 text-destructive mb-4"
        />
        <h1 className="text-2xl font-bold mb-2">Access Denied</h1>
        <p className="text-muted-foreground mb-6">
          You don&apos;t have permission to access this page.
        </p>
        <Button asChild>
          <Link to="/">Return Home</Link>
        </Button>
      </div>
    );
  }

  return <Outlet />;
}
